







































import Vue, { PropType } from 'vue';
import { Component, Prop } from 'vue-property-decorator';

export interface CSelectButtonsPropsItems {
  text: string;
  value: any;
}

@Component({})
export default class CSelectButtons extends Vue {
  @Prop({ type: Array as PropType<string[]> })
  public errorMessages!: string[];

  @Prop({ type: [String, Number] as PropType<string | number>, default: '1/1' })
  public size!: string | number;

  @Prop({ type: [String, Number] as PropType<string | number>, default: '1/1' })
  public pcSize!: string | number;

  @Prop({ type: Array as PropType<CSelectButtonsPropsItems[]> })
  public items!: CSelectButtonsPropsItems[];

  @Prop()
  public value!: any;

  get cssSize(): string {
    const size = this.$vuetify.breakpoint.mobile
      ? this.size
      : this.pcSize || this.size;
    if (String(size).includes('/')) {
      const parts = String(size).split('/').map(Number);
      return `calc((100% * ${parts[0]}) / ${parts[1]})`;
    }
    return `calc(100% * ${String(size)})`;
  }
}
